import { c as _c } from "react/compiler-runtime";
import { Badge, Group } from "@mantine/core";
import { Icon } from "@iconify/react";
import Link from "next/link";
export default function PeopleSearch(t0) {
  const $ = _c(12);
  const {
    psearch
  } = t0;
  let t1;
  if ($[0] !== psearch?.slinks) {
    t1 = psearch?.slinks || [];
    $[0] = psearch?.slinks;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slinks = t1;
  const t2 = psearch?.heading || "People also search for";
  let t3;
  if ($[2] !== t2) {
    t3 = <h2 className="text-xl lg:text-2xl mb-2">{t2}</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== psearch?.icon || $[5] !== slinks) {
    t4 = slinks?.map((slink, index) => <Link href={slink?.link || "/"} key={index}><Badge tt="capitalize" title={slink?.title || "title"} size="xl" c="blue.9" variant="default" rightSection={<Icon icon={psearch?.icon} size="lg" />}>{slink?.title}</Badge></Link>);
    $[4] = psearch?.icon;
    $[5] = slinks;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Group>{t4}</Group>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <section className="section-psearch py-2 lg:py-3" id="psearch"><div className="max-w-7xl mx-auto px-2">{t3}{t5}</div></section>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}